import { Box, Typography, Collapse } from "@mui/material";
import React, { useState } from "react";
import PolicyIcon from "@mui/icons-material/Policy";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

const defaultPolicies = [
  "Moore Exotics is not responsible for setting and communicating the return and refund policies.",
  "Actual appearance of animal may slightly vary from the attached images.",
  "Any request or demand that violates the law or is against legal and ethical standards will not be met or entertained.",
];

const AboutPolicy = ({ listData }) => {
  const [expanded, setExpanded] = useState(false);

  const policy = listData?.seller?.store?.policy;
  const policyLines = policy
    ? [policy]
    : defaultPolicies;

  return (
    <Box>
      {/* Section header */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 3 }}>
        <PolicyIcon sx={{ color: "#FFC001", fontSize: 22 }} />
        <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: { xs: "18px", md: "22px" } }}>
          Store{" "}
          <Box component="span" sx={{ color: "#FFC001" }}>Policy</Box>
        </Typography>
      </Box>

      {/* Policy card */}
      <Box
        sx={{
          backgroundColor: "#1a1a1a",
          border: "1px solid #2a2a2a",
          borderRadius: "12px",
          overflow: "hidden",
        }}
      >
        {/* Top accent */}
        <Box sx={{ height: "2px", backgroundColor: "#FFC001" }} />

        <Box sx={{ p: 3 }}>
          <Typography sx={{ color: "#aaa", fontSize: "13px", mb: 2, fontStyle: "italic" }}>
            Terms of Sale — By making a purchase, you are accepting these terms.
          </Typography>

          {/* Always show first policy item */}
          <Typography
            sx={{
              color: "#ccc",
              fontSize: { xs: "13px", md: "14px" },
              lineHeight: 1.8,
              borderLeft: "2px solid #FFC001",
              pl: 2,
            }}
          >
            {policyLines[0]}
          </Typography>

          {/* Collapsible extra items */}
          {policyLines.length > 1 && (
            <Collapse in={expanded}>
              <Box sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 2 }}>
                {policyLines.slice(1).map((line, i) => (
                  <Typography
                    key={i}
                    sx={{
                      color: "#ccc",
                      fontSize: { xs: "13px", md: "14px" },
                      lineHeight: 1.8,
                      borderLeft: "2px solid #333",
                      pl: 2,
                    }}
                  >
                    {line}
                  </Typography>
                ))}
              </Box>
            </Collapse>
          )}
        </Box>

        {/* Toggle button */}
        {policyLines.length > 1 && (
          <Box
            onClick={() => setExpanded((v) => !v)}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.5,
              px: 3,
              py: 1.5,
              borderTop: "1px solid #2a2a2a",
              cursor: "pointer",
              backgroundColor: "#111",
              color: "#FFC001",
              fontSize: "13px",
              fontWeight: 700,
              userSelect: "none",
              transition: "background 0.2s",
              "&:hover": { backgroundColor: "#1e1e1e" },
            }}
          >
            {expanded ? <ExpandLessIcon sx={{ fontSize: 18 }} /> : <ExpandMoreIcon sx={{ fontSize: 18 }} />}
            {expanded ? "View Less" : "View Full Policy"}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default AboutPolicy;
